'use es6';

import { createSelector } from 'reselect';
import { getThreadByThreadId } from './getThreadByThreadId';
import { getCurrentUrl } from '../operators/getCurrentUrl';
export const getCurrentUrlByThreadId = createSelector([getThreadByThreadId], getCurrentUrl);